import {ApartmentOutlined, BadgeOutlined, PersonOutlineOutlined} from '@mui/icons-material';
import {FC, ReactNode} from 'react';
import {useIntl} from 'react-intl';
import {StatsStrip} from 'src/components/common/StatsStrip';
import {StatsStripTone} from 'src/components/common/StatsStrip/StatsStrip.types';
import {EmployeeStatsStripType} from './EmployeeStatsStrip.types';

/** Who picks up the bill for what this person charges. There are only these two answers. */
const STRIP_MODES = ['COMPANY', 'EMPLOYEE'];

const MODE_LABELS: Record<string, string> = {
    COMPANY: 'employeePaysCompany',
    EMPLOYEE: 'employeePaysEmployee',
};

const MODE_ICONS: Record<string, ReactNode> = {
    COMPANY: <ApartmentOutlined/>,
    EMPLOYEE: <PersonOutlineOutlined/>,
};

const MODE_TONES: Record<string, StatsStripTone> = {
    COMPANY: 'secondary',
    EMPLOYEE: 'primary',
};

export const EmployeeStatsStrip: FC<EmployeeStatsStripType> = ({
                                                                   data,
                                                                   activeMode,
                                                                   onSelectMode,
                                                                   activeGap,
                                                                   onSelectGap,
                                                               }) => {
    const intl = useIntl();
    const counts = new Map((data?.paymentModes ?? []).map((point) => [point.mode, point.employees]));

    return (
        <StatsStrip
            icon={<BadgeOutlined/>}
            title="employees"
            subtitle={intl.formatMessage(
                {id: 'employeeStatsSubtitle'},
                {employees: data?.employees ?? 0}
            )}
            // Two kinds of unfinished: a card is what lets them charge, an activation is what lets
            // them sign in. Neither is a kind of employee, so neither is a tile.
            pills={[
                {
                    key: 'withoutTag',
                    label: 'employeesWithoutTag',
                    value: data?.withoutTag,
                    tone: 'danger',
                    active: activeGap === 'withoutTag',
                    onClick: onSelectGap ? () => onSelectGap('withoutTag') : undefined,
                },
                {
                    key: 'notActivated',
                    label: 'employeesNotActivated',
                    value: data?.notActivated,
                    tone: 'warning',
                    active: activeGap === 'notActivated',
                    onClick: onSelectGap ? () => onSelectGap('notActivated') : undefined,
                },
            ]}
            tiles={STRIP_MODES.map((mode) => ({
                key: mode,
                label: MODE_LABELS[mode],
                value: counts.get(mode),
                icon: MODE_ICONS[mode],
                tone: MODE_TONES[mode],
                active: activeMode === mode,
                onClick: onSelectMode ? () => onSelectMode(mode) : undefined,
            }))}
        />
    );
};
